import CONFIG from '@/config';
import React from 'react';

export const ENV_DEV = 'dev';
export const ENV_STAGING = 'staging';
export const ENV_PRODUCTION = 'production';
export const ENV_LOCALHOST = 'localhost';

const localHostUrlSubstrings = ['127.0.0.1', 'localhost'];
const devUrlSubstring = 'powdev.';
const stagingUrlSubstring = 'powstaging.';
const trainingUrlSubstring = 'powtraining.';
const productionUrlSubstring = 'pow.';

export const evalEnv = () => {
  if (window.location.host.match(devUrlSubstring) !== null) {
    return ENV_DEV;
  } else if (window.location.host.match(stagingUrlSubstring) !== null) {
    return ENV_STAGING;
  } else if (window.location.host.match(trainingUrlSubstring) !== null) {
    return ENV_STAGING;
  } else if (window.location.host.match(productionUrlSubstring) !== null) {
    return ENV_PRODUCTION;
  } else if (
    localHostUrlSubstrings.filter(s => window.location.host.match(s)).length > 0
  ) {
    return ENV_LOCALHOST;
  }
};

export const RuntimeInfoContext = React.createContext<{
  name: string;
  environment: string;
}>(null);

export type RuntimeInfoProviderProps = { children: React.ReactNode };

export const RuntimeInfoProvider: React.FC<RuntimeInfoProviderProps> = ({
  children
}) => {
  return (
    <RuntimeInfoContext.Provider
      value={{
        name: CONFIG.ENV_NAME,
        environment: evalEnv()
      }}
    >
      {children}
    </RuntimeInfoContext.Provider>
  );
};
